import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { type PromoCampaignBody, createPromoCampaign } from '~/services/LuxLoyalty';

import { promoCampaignQueryKeys } from './promoCampaignQueryKeys';

interface CreatePromoCampaignParams {
  campaign: PromoCampaignBody;
  userIds?: Array<string>;
}

export function useCreatePromoCampaign() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (params: CreatePromoCampaignParams) => {
      return await createPromoCampaign(params);
    },
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: promoCampaignQueryKeys.all });
      enqueueSnackbar('Promo campaign created successfully', { variant: 'success' });

      const stats = response.result.assignmentStats;
      if (stats.received > 0 || stats.created > 0 || stats.duplicatesSkipped > 0) {
        enqueueSnackbar(
          `Assignment stats - received: ${stats.received}, created: ${stats.created}, duplicates skipped: ${stats.duplicatesSkipped}`,
          { variant: 'info' },
        );
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error creating promo campaign: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
